import { useFormikContext } from 'formik';
import { FormikTextField } from '../../../../components/form-components/common-components/text-field/FormikTextField';
import { FormikDropdown } from '../../../../components/form-components/common-components/dropdown/FormikDropdown';
import {
  calculateTotalHoursFromStrings,
  type OvertimeFormValues,
} from './overtimeFormUtils';
import { overtimeFieldIcons as HRI } from './overtimeFieldIcons';
import styles from './NewOvertimePopup.module.css';

const STATUS_OPTIONS = [
  { value: 'Pending', label: 'Beklemede' },
  { value: 'Approved', label: 'Onaylandı' },
  { value: 'Rejected', label: 'Reddedildi' },
];

type OvertimeFormFieldsProps = {
  descriptionPlaceholder: string;
  showStatus?: boolean;
};

const OvertimeFormFields = ({
  descriptionPlaceholder,
  showStatus = false,
}: OvertimeFormFieldsProps) => {
  const { values } = useFormikContext<OvertimeFormValues>();
  const totalHours = calculateTotalHoursFromStrings(values.startDate, values.endDate);

  return (
    <>
      <div className={styles.formRow}>
        <div className={styles.inputContainer}>
          <FormikTextField
            name="startDate"
            label="Başlangıç Tarihi"
            type="datetime-local"
            startIcon={HRI.startDate}
          />
        </div>
        <div className={styles.inputContainer}>
          <FormikTextField
            name="endDate"
            label="Bitiş Tarihi"
            type="datetime-local"
            startIcon={HRI.endDate}
          />
        </div>
      </div>

      <div className={styles.inputContainer}>
        <div className={styles.totalHoursBox}>
          <span className={styles.totalHoursIcon} aria-hidden="true">
            {HRI.totalHours}
          </span>
          <div className={styles.totalHoursContent}>
            <span className={styles.totalHoursLabel}>Toplam Saat</span>
            <span className={styles.totalHoursValue}>{totalHours} saat</span>
          </div>
        </div>
      </div>

      <div className={styles.inputContainer}>
        <FormikTextField
          name="description"
          label="Açıklama"
          placeholder={descriptionPlaceholder}
          multiline
          rows={3}
          disableUppercase
          startIcon={HRI.description}
        />
      </div>

      {showStatus ? (
        <div className={styles.inputContainer}>
          <FormikDropdown
            name="status"
            label="Durum"
            placeholder="Durum seçiniz"
            options={STATUS_OPTIONS}
            startIcon={HRI.status}
          />
        </div>
      ) : null}

      {showStatus && values.status === 'Rejected' ? (
        <div className={styles.inputContainer}>
          <FormikTextField
            name="rejectionReason"
            label="Red Sebebi"
            placeholder="Red sebebini giriniz..."
            multiline
            rows={3}
            disableUppercase
            startIcon={HRI.rejectionReason}
          />
        </div>
      ) : null}
    </>
  );
};

export default OvertimeFormFields;
